import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  Grid,
  Typography,
  Stack,
  CircularProgress,
} from "@mui/material";
import "../App.css";
import Navbar from "../components/Navbar";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { GoogleLogin } from "react-google-login";
import { login, googleLoginInfo, createRequest } from "../apis";
import _ from "lodash";
import PageHeader from "../components/PageHeader";
import SignInImage from "../assets/Images/SignIn.png";
import { isMobile } from "react-device-detect";
import LogoImage from "../assets/Images/Vector.png";

const Login = () => {
  const [enteredEmail, setEnteredEmail] = useState("");
  const [enteredPassword, setEnteredPassword] = useState("");
  const [res, setRes] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/login");
    } else {
      navigate("/");
    }
  }, []);

  const LoginButtonHandler = async () => {
    setButtonLoading(true);
    const data = await login({
      email: enteredEmail,
      password: enteredPassword,
    });
    setRes(data.data);
    setButtonLoading(false);
    if (localStorage.getItem("createRequestStatus") == "true") {
      let payload = JSON.parse(localStorage.getItem("createRequest"));
      payload.userid = data.data.userInfo._id;
      payload.email = data.data.email;
      payload.creatorName = data.data.fullName;
      let data = await createRequest(payload);
    }
  };

  useEffect(() => {
    if (res.success == true) {
      localStorage.setItem("user-info", JSON.stringify(res.userInfo));
      localStorage.setItem("user-type", res.userType);
      if (res.userType == "user") {
        if (localStorage.getItem("createRequestStatus") == "true") {
          localStorage.setItem("createRequestStatus", "false");
          navigate("/request-submitted");
        } else {
          navigate("/");
        }
      } else {
        if (
          res.userInfo.isActive == false &&
          res.userInfo.infoFilled == false
        ) {
          navigate("/service-provider/info");
        } else if (
          res.userInfo.isActive == false &&
          res.userInfo.infoFilled == true
        ) {
          navigate("/service-provider/under-review");
        } else {
          navigate("/feeds");
        }
      }
    }
  }, [res]);

  const onSuccessGoogle = async (res) => {
    setButtonLoading(true);
    localStorage.setItem("user-info", JSON.stringify(res.profileObj));
    localStorage.setItem("user-type", "user");
    await googleLoginInfo({
      email: res.profileObj.email,
      fullName: res.profileObj.name,
      googleId: res.profileObj.googleId,
      imageUrl: res.profileObj.imageUrl,
    });

    if (localStorage.getItem("createRequestStatus") == "true") {
      console.log("if entered");
      let payload = JSON.parse(localStorage.getItem("createRequest"));
      payload.userid = res.profileObj.googleId;
      payload.email = res.profileObj.email;
      payload.creatorName = res.profileObj.name;
      let data = await createRequest(payload);
      localStorage.setItem("createRequestStatus", "false");
      if (data) {
        navigate("/request-submitted");
      }
    } else {
      console.log("else entered");
      navigate("/");
    }
    setButtonLoading(false);
  };

  const onFailureGoogle = (res) => {
    console.log("Login Failed res: ", res);
  };
  if (isMobile) {
    return (
      <Box
        sx={{ display: "flex" }}
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Stack direction="column">
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            className="mb-5"
            justifyContent="center"
            style={{ width: "100%" }}
          >
            <img
              src={LogoImage}
              alt="logo"
              style={{ height: "33px", width: "50px" }}
            />
            <span
              className="default-color"
              style={{
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              Amannat
            </span>
          </Stack>
          <Stack>
            <Typography>Please download the Ammanat Mobile App.</Typography>
          </Stack>
        </Stack>
      </Box>
    );
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={12} md={6}>
          <Container maxWidth="sm" style={{ height: "100vh" }}>
            <PageHeader />
            <Box style={{ marginTop: "100px" }}>
              <Grid container spacing={2}>
                <span>
                  <h3 className="ml-9">Sign In</h3>
                  <p className="ml-9">
                    <span style={{ color: "#7A7A80" }}>New to Amannat?</span>{" "}
                    <Link to="/choose-flow" state={{ flow: "register" }}>
                      <span style={{ color: "#0A64BC", fontWeight: "bold" }}>
                        SIgn Up here
                      </span>
                    </Link>
                  </p>
                </span>
                <div className="login-form">
                  <Typography style={{ fontWeight: "bold" }}>Email</Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter your email address"
                    variant="outlined"
                    onChange={(e) => setEnteredEmail(e.target.value)}
                  />
                  {!res.success ? (
                    <span className="mt-3" style={{ color: "red" }}>
                      {res.message}
                    </span>
                  ) : null}
                  <Typography style={{ fontWeight: "bold" }} className="mt-13">
                    Password
                  </Typography>
                  <TextField
                    required
                    size="small"
                    id="outlined-basic"
                    placeholder="Enter your password"
                    variant="outlined"
                    type="password"
                    onChange={(e) => setEnteredPassword(e.target.value)}
                  />
                  {!res.success ? (
                    <span className="mt-3" style={{ color: "red" }}>
                      {res.message}
                    </span>
                  ) : null}

                  {buttonLoading ? (
                    <span className="text-align-center">
                      <Button
                        variant="contained"
                        onClick={LoginButtonHandler}
                        className="mt-13 primary-button"
                        style={{ width: "100%" }}
                        disabled
                      >
                        <CircularProgress
                          style={{ color: "white" }}
                          size={25}
                        />
                      </Button>
                    </span>
                  ) : (
                    <span className="text-align-center">
                      <Button
                        variant="contained"
                        onClick={LoginButtonHandler}
                        className="mt-13 primary-button"
                        style={{ width: "100%" }}
                      >
                        Login
                      </Button>
                    </span>
                  )}

                  <span
                    className="text-align-center mt-8 mb-8"
                    style={{ color: "#7A7A80" }}
                  >
                    Or continue with
                  </span>

                  <span className="text-align-center mb-6">
                    <GoogleLogin
                      clientId="469270145255-938kdgrj0kb2ikjs4ef9sqdbm1bi8omo.apps.googleusercontent.com"
                      buttonText="Continue with Google"
                      onSuccess={onSuccessGoogle}
                      onFailure={onFailureGoogle}
                      cookiePolicy={"single_host_origin"}
                      disabled={buttonLoading ? true : false}
                    />
                  </span>
                  {/* <span className="text-align-center mb-6">
                    Don't have an account?{" "}
                    <Link
                      to="/register"
                      className="text-decoration-none text-bold"
                    >
                      Register Here
                    </Link>
                  </span> */}
                </div>
              </Grid>
            </Box>
          </Container>
        </Grid>
        <Grid item sm={12} md={6}>
          <div>
            <img
              src={SignInImage}
              style={{ width: "100%", height: "100vh" }}
              loading="lazy"
            />
            <Typography
              style={{
                position: "absolute",
                top: "75%",
                color: "white",
                fontWeight: "700",
                fontSize: "28px",
                lineHeight: "37px",
                padding: "20px",
              }}
            >
              What a great experience using Amaanat! I booked all of my services
              for my gap year through Amannat and never had any issues.{" "}
            </Typography>
            <Typography
              style={{
                position: "absolute",
                top: "90%",
                color: "white",
                fontWeight: "000",
                fontSize: "20px",
                lineHeight: "27px",
                padding: "20px",
              }}
            >
              Sara Loren
            </Typography>
          </div>
        </Grid>
      </Grid>
    </>
  );

  //   return <div className="main-containter">
  //     <Card >
  //    <span>
  //     <h3 className="ml-9">
  //       Log In
  //     </h3>
  //     <p className="ml-9">Please create and account and stay updated.</p>
  //     </span>
  //     <form action="submit" className="login-form">
  //     <TextField id="outlined-basic" label="Email Address" variant="outlined" />
  //     <TextField id="outlined-basic" label="Password" variant="outlined" type='password' className="mt-13"/>
  //     <span className="text-align-center">
  //     <Button variant="contained" type='submit' className="mt-13 w-43">Login</Button>
  //     </span>

  //       <span className="text-align-center mt-8 mb-8">OR</span>
  //       <span className="text-align-center">
  //       <Button variant="outlined" className="login-with-google-btn mb-6">Sign in with Google</Button>
  //       {/* <Button variant="contained" class="login-with-google-btn" >
  //   Sign in with Google
  // </Button> */}
  // </span>
  // <span className="text-align-center mb-6">Don't have an account? <a href="#" className="text-decoration-none text-bold">Login Here</a></span>
  //     </form>
  //     </Card>
  //   </div>;
};

export default Login;
